export default "__VITE_ASSET__SagQj4sX__"